// NOTE: This is temporary ignore because we need data from AccountProvider
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import BaseTopMatter from 'reservations/account/components/BaseTopMatter';
import { LogoOnlyLayout } from 'reservations/account/components/HeaderLayouts/LogoOnlyLayout';
import { TextAndLogoLayout } from 'reservations/account/components/HeaderLayouts/TextAndLogoLayout';
import { TextOnlyLayout } from 'reservations/account/components/HeaderLayouts/TextOnlyLayout';
import {
  LOGO_ONLY_LAYOUT,
  TEXT_AND_LOGO_LAYOUT,
  TEXT_ONLY_LAYOUT
} from 'reservations/account/constants';
import { useAccount } from 'reservations/account/providers/AccountProvider';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';
import muiPropForwarding from 'reservations/brand/helpers/muiPropForwarding';
import { usePreviewModeContext } from 'reservations/preview/providers/PreviewModeProvider';

type StyledTopMatterProps = {
  isDesktop: boolean;
};

const StyledTopMatterNameAndDetailsContainer = styled(Grid, {
  shouldForwardProp: muiPropForwarding('isDesktop')
})<StyledTopMatterProps>({
  width: '100%',
  minHeight: '120px',
  maxHeight: '220px',
  display: 'flex',
  justifyContent: 'end'
});

const HEADER_LAYOUT_COMPONENTS = {
  [TEXT_ONLY_LAYOUT]: TextOnlyLayout,
  [LOGO_ONLY_LAYOUT]: LogoOnlyLayout,
  [TEXT_AND_LOGO_LAYOUT]: TextAndLogoLayout
};

type Props = {
  children?: React.ReactNode;
};

const TopMatter = ({ children }: Props) => {
  const { headerLayout: accountHeaderLayout } = useAccount();
  const { isPreview, previewData } = usePreviewModeContext();
  const headerLayout =
    isPreview && previewData?.header_layout
      ? previewData?.header_layout
      : accountHeaderLayout;

  const isDesktop = useIsDesktop();
  const HeaderComponent = HEADER_LAYOUT_COMPONENTS[headerLayout];

  return (
    <BaseTopMatter>
      <StyledTopMatterNameAndDetailsContainer
        container
        alignContent="start"
        direction="column"
        rowSpacing="40px"
        isDesktop={isDesktop}
      >
        <HeaderComponent />
        {children}
      </StyledTopMatterNameAndDetailsContainer>
    </BaseTopMatter>
  );
};

export default TopMatter;
